import { viewTabHandle } from "@yjsgames/phaser-ui/tab-registry";
import type { DomainBootstrapper } from "./BootTypes.js";
import { t } from "../i18n/i18n.js";
import { buildWorldTabCells, type WorldTabCell } from "../ui/worldTabData.js";
import { WorldTabView, type WorldTabData } from "../ui/WorldTabView.js";

export const worldBoot: DomainBootstrapper = {
  key: "world",
  install(boot) {
    boot.tabs.registerLazy("world", {
      mount: () => {
        const { tabContent } = boot.layout;
        const buildData = (): WorldTabData => ({
          cells: buildWorldTabCells(
            boot.ctx.chapter().currentChapter,
            boot.ctx.chapter().bestChapter,
          ),
        });
        const openMoveConfirm = (cell: WorldTabCell) => {
          if (!cell.canMove) {
            boot.ui.showToast(
              cell.status === "locked" ? t("world.lockedToast") : t("world.currentToast"),
            );
            return;
          }
          const screen = boot.screen();
          boot.modals.openWorldMoveConfirm({
            screenWidth: screen.width,
            screenHeight: screen.height,
            worldName: t("world.card.title", { worldNo: cell.worldNo, name: t(cell.nameKey) }),
            onConfirm: () => {
              boot.modals.closeWorldMoveConfirm();
              boot.progression.moveToWorld(cell.worldNo);
            },
            onCancel: () => boot.modals.closeWorldMoveConfirm(),
          });
        };
        const view = new WorldTabView(
          boot.scene,
          tabContent.x,
          tabContent.y,
          tabContent.width,
          boot.layout.shell.tabPanelBottom,
          { onMove: openMoveConfirm },
        );
        const signature = () => {
          const ch = boot.ctx.chapter();
          return `${ch.currentChapter}:${ch.bestChapter}`;
        };
        return viewTabHandle(view, () => view.update(buildData()), signature);
      },
    });
  },
};
